import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const cadastrarMotivo = ({ descricao, observacao, idc_status }) => {
  return axios.post(
    process.env.URL_API_BASE + '/motorista-pendencia-motivo',
    {
      descricao: descricao,
      observacao: observacao,
      idc_status: idc_status,
      created_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const alterarMotivo = ({ id, descricao, observacao, idc_status }) => {
  return axios.patch(
    process.env.URL_API_BASE + '/motorista-pendencia-motivo/' + id,
    {
      descricao: descricao,
      observacao: observacao,
      idc_status: idc_status,
      updated_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const listarMotivo = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/motorista-pendencia-motivo',
    config
  )
  return response.data
}

export const obterMotivo = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/motorista-pendencia-motivo/' + id,
    config
  )
  return response.data
}

const listarMotivosAtivos = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/motorista-pendencia-motivo/listar-ativos/1',
    config
  )
  return response.data
}

export default {
  cadastrarMotivo,
  alterarMotivo,
  listarMotivo,
  obterMotivo,
  listarMotivosAtivos
}



// WEBPACK FOOTER //
// ./src/actions/MotoristaPendenciaMotivoActions.js